<script setup lang="ts">
type IconColor = 'red' | 'white'

interface Props {
  color: IconColor
}

withDefaults(defineProps<Props>(), {
  color: 'white',
})
</script>

<template>
  <svg :class="['icon', `icon--${color}`]" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g clip-path="url(#clip0_3743_2120)">
      <path
        d="M23.9999 10.6673H22.6666V8.00065C22.6666 4.32065 19.6799 1.33398 15.9999 1.33398C12.3199 1.33398 9.33325 4.32065 9.33325 8.00065V10.6673H7.99992C6.53325 10.6673 5.33325 11.8673 5.33325 13.334V26.6673C5.33325 28.134 6.53325 29.334 7.99992 29.334H23.9999C25.4666 29.334 26.6666 28.134 26.6666 26.6673V13.334C26.6666 11.8673 25.4666 10.6673 23.9999 10.6673ZM11.9999 8.00065C11.9999 5.78732 13.7866 4.00065 15.9999 4.00065C18.2133 4.00065 19.9999 5.78732 19.9999 8.00065V10.6673H11.9999V8.00065ZM23.9999 26.6673H7.99992V13.334H23.9999V26.6673ZM15.9999 22.6673C17.4666 22.6673 18.6666 21.4673 18.6666 20.0007C18.6666 18.534 17.4666 17.334 15.9999 17.334C14.5333 17.334 13.3333 18.534 13.3333 20.0007C13.3333 21.4673 14.5333 22.6673 15.9999 22.6673Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_3743_2120">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.icon {
  &--red {
    path {
      fill: #ff2424;
    }
  }

  &--white {
    path {
      fill: var(--lightest);
    }
  }
}
</style>
